import React, { useEffect, useRef, useState } from "react";
import c from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import queryString from "query-string";
import moment from "moment";

import { wp } from "../providers/content";

import css from "./layout.module.scss";

const availablePostTypes = [
  { type: "content", slug: "default", name: "Redaktionelle Beiträge", nameSingle: "Redaktioneller Beitrag" },
  { type: "content", slug: "mebm_tool", name: "Tools", nameSingle: "Tool" },
  { type: "content", slug: "mebm_tutorial", name: "Tutorials", nameSingle: "Tutorial" },
  { type: "content", slug: "tribe_events", name: "Veranstaltungen", nameSingle: "Veranstaltung" },
  { type: "content", slug: "mebm_rental_media", name: "Verleihmedien", nameSingle: "Verleihmedium" },
];

const truncateText = (input, numChars) => (input.length > numChars ? `${input.substring(0, numChars)}...` : input);

const filterUnique = (value, index, array) => {
  return array.indexOf(value) === index;
};

const SearchResultGroup = ({ searchResults, searchString, searchPage }) => {
  return (
    <>
      {searchResults && searchResults.length > 0 ? (
        searchResults.map((result, index) => (
          <a
            href={result.href}
            className={c(
              "list-group-item list-group-item-action border-left-0 border-right-0",
              index === searchResults.length - 1 && "border-bottom-0",
              index === 0 && "border-top-0"
            )}
            key={index}
          >
            <div className="media">
              <img
                className="mr-3"
                width="65"
                height={result.post_type === "mebm_rental_media" ? "37" : "65"}
                src={result.media}
                style={
                  result.post_type === "mebm_rental_media"
                    ? {
                        marginTop: "14px",
                        backgroundImage: "url(/wp-content/themes/medienbildung-muenchen-theme/img/rental-media-fallback.png)",
                        backgroundSize: "cover",
                        backgroundRepeat: "no-repeat"
                      }
                    : {}
                }
              />
              <div className="media-body">
                <h6 className="mt-0">
                  <span
                    dangerouslySetInnerHTML={{
                      __html: result.highlight?.title?.snippet || result.title,
                    }}
                  />
                  <span className="badge badge-secondary ml-2 rounded p-1 float-right">{availablePostTypes.find(pt => pt.slug === result.post_type).nameSingle}</span>
                  {result.post_type === "tribe_events" && (
                    <span className="badge badge-danger float-right ml-2">{moment.unix(result.start_date).zone(0).format("DD.MM.YY, hh:mm")} Uhr</span>
                  )}
                </h6>
                <p className="text-dark">
                  <small
                    dangerouslySetInnerHTML={{
                      __html: result.highlight?.content?.snippet
                        ? `… ${result.highlight.content.snippet} …`
                        : truncateText(result.excerpt, 250),
                    }}
                  />
                </p>
              </div>
            </div>
          </a>
        ))
      ) : (
        <a className={c("list-group-item list-group-item-action disabled border-0 p-0", searchPage || "p-2")}>Keine Ergebnisse</a>
      )}
      {searchPage || (
        <a className="list-group-item list-group-item-action bg-primary border-0 p-2 text-white text-center" href={`/?s=${searchString}`}>
          Mehr Ergebnisse & erweiterte Suche <FontAwesomeIcon icon="chevron-right" />{" "}
        </a>
      )}
    </>
  );
};

const TagSelection = ({ title, availableSelections, value, onChange, perPage }) => {
  const [popularityOrder, setPopularityOrder] = useState(true);

  const [page, setPage] = useState(1);

  const maxPage = parseInt(Math.ceil(availableSelections.length / perPage));

  const next = () => {
    const nextPage = page + 1;
    setPage(nextPage > maxPage ? 1 : nextPage);
  };

  const prev = () => {
    const prevPage = page - 1;
    setPage(prevPage < 1 ? maxPage : prevPage);
  };

  let activeSelections = [],
    selections = [];

  availableSelections.forEach((selection) => {
    let active = false;
    (value || []).forEach((pair) => {
      const type = pair[0];
      const slug = pair[1];
      if (selection.slug === slug && selection.type === type) {
        active = true;
      }
    });
    active ? activeSelections.push(selection) : selections.push(selection);
  });

  selections = popularityOrder
    ? selections
    : JSON.parse(JSON.stringify(selections)).sort(function (a, b) {
        const nameA = a.name.toLowerCase(),
          nameB = b.name.toLowerCase();

        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });

  return (
    <div className="mb-2">
      <div className="d-flex justify-content-between">
        <h6>{title}</h6>
        {maxPage > 1 && (
          <div>
            <button
              className="btn btn-link btn-sm"
              onClick={() => {
                setPage(1);
                setPopularityOrder(!popularityOrder);
              }}
            >
              <FontAwesomeIcon icon={popularityOrder ? "arrow-down-9-1" : "arrow-down-a-z"} />
            </button>
            <button className="btn btn-link btn-sm" onClick={prev}>
              <FontAwesomeIcon icon="chevron-left" />{" "}
            </button>
            <small className="px-2">
              {page} / {maxPage}
            </small>
            <button className="btn btn-link btn-sm" onClick={next}>
              <FontAwesomeIcon icon="chevron-right" />{" "}
            </button>
          </div>
        )}
      </div>
      {activeSelections.map((selection, index) => (
        <button
          key={index}
          type="button"
          onClick={() => {
            onChange(
              value.filter((active) => {
                return !(active[0] === selection.type && active[1] === selection.slug);
              })
            );
          }}
          className={c("btn btn-sm rounded mr-2 mb-2 btn-primary")}
        >
          <small>{selection.name.replace(/\(\d+\)$/, "")}</small>
        </button>
      ))}
      {selections.slice((page - 1) * perPage, page * perPage).map((selection, index) => (
        <button
          key={index}
          type="button"
          onClick={() => {
            onChange((value || []).concat([[selection.type, selection.slug]]));
          }}
          className={c("btn btn-sm rounded mr-2 mb-2 btn-secondary")}
        >
          <small>{selection.name}</small>
        </button>
      ))}
    </div>
  );
};

const Search = ({ 
  searchPage, 
  urlState,
  className, 
  fixedPostTypes,
  numPreviewResults,
  initialSearchString 
}) => {
  const searchRef = useRef(null);
  const serachResultsContainerRef = useRef(null);
  const { history, location } = window;

  const parsedSearchParams = queryString.parse(location.search, { arrayFormat: "bracket" });

  const [tags, setTags] = useState([]);

  const tagPairSep = ":";

  const defaultTypes = fixedPostTypes || ["default", "tribe_events", "mebm_tool", "mebm_tutorial"];

  const [searchParams, setSearchParams] = useState(
    urlState
      ? {
          searchString: parsedSearchParams.s,
          types: parsedSearchParams.types || defaultTypes,
          activeTags: (parsedSearchParams.tags || []).map((pair) => pair.split(tagPairSep)),
        }
      : {
          searchString: initialSearchString || "",
          types: defaultTypes,
          activeTags: [],
        }
  );


  const { searchString, types, activeTags } = searchParams;

  const [searchActive, setSearchActive] = useState(searchPage);
  const [searchResults, setSearchResults] = useState([]);

  const [loadingHeight, setLoadingHeight] = useState();
  

  useEffect(() => {
    const handleKeyDown = (event) => {
      const isModifierPressed = event.ctrlKey || event.metaKey;

      if (isModifierPressed && event.key.toLowerCase() === 'k') {
        event.preventDefault();
        searchRef.current?.focus();
      }

      if (event.key === 'Escape') {
        setSearchActive(false);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  useEffect(() => {
    if(searchPage) {
      const timer = setTimeout(() => {
        if(searchRef.current) {
          searchRef.current.focus();
        }
      }, 500);
      return () => clearTimeout(timer);
    }
  }, []);

  useEffect(() => {
    setLoadingHeight(serachResultsContainerRef?.current?.offsetHeight);
    if (searchString.trim().length > 0 || searchPage) {
      setSearchActive(true);
    }
  }, [searchString]);

  useEffect(() => {
    if (urlState) {
      const url = queryString.stringify(
        {
          s: searchString,
          types: types,
          tags: (activeTags || []).map((pair) => pair.join(tagPairSep)),
        },
        { arrayFormat: "bracket" }
      );
      history.replaceState(searchParams, "", `?${url}`);
    }

    if (searchActive) {
      setSearchResults(undefined);
      wp.tax_by_slugs()
        .create({
          terms: activeTags,
        })
        .then((fetchedTags) => {
          const activeTagObjects = fetchedTags || [];
          const activeTagIds = activeTagObjects.map((tag) => tag.id);
          wp.search()
            .create({
              query: searchString,
              types: types,
              tags: activeTagIds,
              count: numPreviewResults || (searchPage ? 10 : 3),
            })
            .then((searchResponse) => {
              const availableTags = (searchResponse.available_tags || []).concat(activeTagObjects);

              const newTags = availableTags.reduce((accumulator, current) => {
                const exists = accumulator.find((item) => item.id === current.id);
                if (!exists) {
                  accumulator = accumulator.concat(current);
                }
                return accumulator;
              }, []);
              setTags(newTags);
              setSearchResults(searchResponse.results || []);
            });
        });
    } else {
      setSearchParams({
        ...searchParams,
        types: defaultTypes,
      });
      setTags([]);
    }
  }, [searchActive, searchString, JSON.stringify(types), JSON.stringify(searchParams.activeTags)]);

  const TagSelectionFiltered = ({ title, types, perPage }) => {

    const filteredTags = tags.filter((tag) => types.includes(tag.type));
    const availableTagTypeCount = tags.map((tag) => tag.type).filter(filterUnique).length;
    if (filteredTags.length === 0) {
      return null;
    }
    return (
      <TagSelection
        perPage={parseInt(Math.ceil(18 / availableTagTypeCount))}
        title={title}
        value={activeTags}
        onChange={(slugs) => {
          setSearchParams({
            ...searchParams,
            activeTags: slugs,
          });
        }}
        availableSelections={filteredTags}
      />
    );
  };

  return (
    <form
      role="search"
      className={c(className, "input-group", css["search-form"])}
      onSubmit={(e) => {
        e.preventDefault();
        if(!searchPage) {
          location.replace(`/?s=${searchParams.searchString}`);  
        }
      }}
    >
      {searchPage && <h6>Suche</h6>}
      <div className={c("d-flex p-2 w-100", searchPage && "border")}>
        <div className="input-group-prepend">
          <span
            className="input-group-text border-white bg-white"
            style={{ cursor: "pointer" }}
            onClick={(e) => {
              e.preventDefault();
            }}
          >
            <FontAwesomeIcon icon="search" size="xs"/>
          </span>
        </div>
        <input
          type="search"
          className="form-control border-0 px-1 flex-grow-1"
          placeholder="Suchen"
          style={{ boxShadow: "none" }}
          value={searchString}
          ref={searchRef}
          onChange={(e) => {
            e.preventDefault();
            setSearchParams({
              ...searchParams,
              searchString: e.target.value,
            });
          }}
          onFocus={(e) => {
            e.preventDefault();
            setSearchActive(true);
          }}
        />

        {((!searchPage && searchActive > 0) || (searchPage && searchString.length > 0)) && (
          <>
            <a
              href="#"
              className="input-group-append"
              onClick={(e) => {
                e.preventDefault();
                setSearchActive(searchPage ? true : false);
                setSearchParams({
                  searchString: "",
                  types: defaultTypes,
                  activeTags: [],
                });
              }}
            >
              <span className="input-group-text border-white bg-white">
                <FontAwesomeIcon icon="times" size="xs" />
              </span>
            </a>
          </>
        )}
      </div>
      {(searchActive || searchPage) && (
        <div className={c(searchPage || css["search-results"], "container", searchPage && "p-0 mt-4")} id="search-results-container">
          <div className={c("list-group bg-white", searchPage || "shadow-lg")} style={loadingHeight ? { minHeight: loadingHeight } : {}}>
            {searchResults === undefined ? (
              <a className="list-group-item list-group-item-action disabled text-center border-0">
                <div className="spinner-border" role="status">
                  <span className="sr-only">Laden...</span>
                </div>
              </a>
            ) : (
              <div ref={serachResultsContainerRef}>
                {searchPage && (
                  <div className="row no-gutters">
                    {fixedPostTypes === undefined &&
                      <div className="col-12 col-md-4">
                        <TagSelection
                          title="Inhaltstyp"
                          value={types.map((type) => ["content", type])}
                          onChange={(newTypes) => {
                            setSearchParams({
                              ...searchParams,
                              activeTags: newTypes.length < types.length ? [] : activeTags,
                              types: newTypes.map((pair) => pair[1]),
                            });
                          }}
                          perPage={5}
                          availableSelections={availablePostTypes}
                        />
                      </div>
                    }
                    {tags.length > 0 && (
                      <div className={fixedPostTypes === undefined ? "col-12 col-md-8" : "col-12"}>
                        <TagSelectionFiltered types={["mebm_rental_media_type"]} title="Medienarten" />
                        <TagSelectionFiltered types={["post_tag", "mebm_rental_media_tag"]} title="Schlagwörter" />
                        <TagSelectionFiltered types={["mebm_rental_media_topic"]} title="Themengebiete" />
                        <TagSelectionFiltered types={["mebm_rental_media_ageclass"]} title="Altersklassen" />
                      </div>
                    )}
                  </div>
                )}
                {searchPage && <h6>Suchergebnisse</h6>}
                <SearchResultGroup searchResults={searchResults} searchPage={searchPage} searchString={searchString} />
              </div>
            )}
          </div>
        </div>
      )}
    </form>
  );
};


export default Search;